import SchedaMorteList from "./pages/SchedaMorteList";
import SchedaMorteEdit from "./pages/SchedaMorteEdit";
import SchedaMorteCodificaGemo from "./pages/SchedaMorteCodificaGemo";
export default {
    SchedaMorteList,
    SchedaMorteEdit,
    SchedaMorteCodificaGemo,
};
